var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "customfields-group" },
    [
      _c(
        "el-checkbox",
        {
          staticClass: "mb-2 bold lh-20",
          attrs: {
            "data-bot": _vm.getDatabot(
              "checkbox",
              _vm.currentStore,
              null,
              "cf-popup"
            ),
            indeterminate: _vm.isIndeterminate
          },
          on: { change: _vm.handleCheckAllChange },
          model: {
            value: _vm.checkAll,
            callback: function($$v) {
              _vm.checkAll = $$v
            },
            expression: "checkAll"
          }
        },
        [_vm._v(_vm._s(_vm.groupName))]
      ),
      _vm._v(" "),
      _c(
        "el-checkbox-group",
        {
          staticClass: "flex-column",
          on: { change: _vm.handleCheckedFieldsChange },
          model: {
            value: _vm.fieldsChecked,
            callback: function($$v) {
              _vm.fieldsChecked = $$v
            },
            expression: "fieldsChecked"
          }
        },
        _vm._l(_vm.group.fields, function(field, index) {
          return _c(
            "el-checkbox",
            {
              key: field.id,
              staticClass: "lh-20 regular",
              class: { "mb-2": index !== _vm.group.fields.length - 1 },
              attrs: {
                "data-bot": _vm.getDatabot(
                  "checkbox",
                  _vm.currentStore,
                  null,
                  "cf-popup"
                ),
                label: field.id,
                disabled: field.mandatory,
                checked: _vm.isChecked(field)
              }
            },
            [_vm._v("\n                " + _vm._s(field.name) + "\n        ")]
          )
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }